import React, { Component } from 'react';
import User from '../../../../../helper/currentUser';
import * as TinyPubSub from '../../../../../helper/TinyPubSub';
import ChannelCardDark from '../ChannelCardDark';

const user = new User();

class ChannelCardPopupItemDark extends Component {
  componentDidMount() {
    TinyPubSub.subscribe('windowEscKeyPressed', this.closePopup);
  }

  componentWillUnmount() {
    TinyPubSub.unsubscribe('windowEscKeyPressed', this.closePopup);
  }

  closePopup() {
    window.location.href = '/#/learner/channels';
  }

  render() {
    return (
      <ChannelCardDark
        rootQ={this.props.rootQ}
        userId={user.id()}
        userObj={this.props.userObj}
        channelName={this.props.channelName}
        params={this.props.params}
        isPreview={this.props.isPreview}
      />
    );
  }
}

export default ChannelCardPopupItemDark;
